import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo, Prelim } from "../../../assets";
import { BaseButton } from "../../../components/button/styled";
import { H3, P, Label, H2, Span } from "../../../components/typography/styled";
import { GetStartedWrapper, GetStartedWrapperRow } from "./styled";
import { BaseFieldSet } from "../../../components/form/fieldset/styled";
import { BaseInput } from "../../../components/form/input/styled";
import { DotLoader } from "react-spinners";
import { GetStartedSuccessModal } from "../../../containers/app/modals/getstartedmodal";
import Cookies from "universal-cookie";
import { verifyUserEmail } from "../../../utils/apis/authentication/employer/verifyEmail";
import { setUserPassword } from "../../../utils/apis/authentication/employer/setPassword";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export const GetStarted = () => {
  const cookies = new Cookies();
  const otpModalRef = useRef();
  const navigate = useNavigate();
  const [showPasswordFields, setShowPasswordFields] = useState({
    password: false,
    confirmPassword: false,
  });

  const [isOTPEntered, setIsOTPEntered] = useState(false);
  const [step, setStep] = useState(1);
  const [error, setError] = useState(null);

  const [token, setToken] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formDetails, setFormDetails] = useState({});

  useEffect(() => {
    if (step === 1) {
      setFormDetails({ email: "" });
    } else if (step === 2) {
      setFormDetails({ password: "", confirmPassword: "" });
    }
  }, [step]);

  useEffect(() => {
    if (isOTPEntered) {
      setStep(2);
      otpModalRef.current.clearOtp();
    }
  }, [isOTPEntered]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOTPModal = () => {
    // update modal to open below
    otpModalRef.current.openOtpModal();
  };

  const handleVerifyEmail = async () => {
    setError(null);
    setIsLoading(true);
    try {
      const response = await verifyUserEmail(formDetails);
      if (response.status === "Success") {
        setToken(response.token);
        setIsLoading(false);
        setUserEmail(formDetails.email);
        setStep(2);
        handleOTPModal();
      } else {
        setIsLoading(false);
        setError(
          "Email verification failed. Please check your credentials and try again.",
        );
        console.error(
          "Email verification failed. Please check your credentials and try again.",
        );
      }
    } catch (error) {
      setIsLoading(false);
      setError(`Email verification failed. ${error.message}`);
      console.error("Email verification failed:", error);
    }
  };

  const handleSetPassword = async () => {
    try {
      const response = await setUserPassword(
        otpModalRef.current.retrieveGetStartedToken(),
        formDetails,
      );
      if (response.status === "Success") {
        setIsLoading(false);
        cookies.set("token", response.token, {
          path: "/",
          maxAge: 1000000,
        });
        if (response.status === "Success") {
          navigate("/login");
        }
      } else {
        setIsLoading(false);
        setError(
          "Set password failed. Please check your credentials and try again.",
        );
        console.error(
          "Set password failed. Please check your credentials and try again.",
        );
      }
    } catch (error) {
      setIsLoading(false);
      setError(`Set password failed. ${error.message}`);
      console.error("Set password failed:", error);
    }
  };

  const validatePassword = (password, confirmPassword) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    // const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    if (password.length < minLength)
      return "Password must be at least 8 characters long.";
    if (!hasUppercase)
      return "Password must contain at least one uppercase letter.";
    if (!hasLowercase)
      return "Password must contain at least one lowercase letter.";
    if (!hasNumber) return "Password must contain at least one number.";
    // if (!hasSpecial)
    //   return "Password must contain at least one special character (!@#$%^&*).";
    if (password !== confirmPassword) return "Passwords do not match.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === 1) {
      return await handleVerifyEmail();
    }
    const passwordError = validatePassword(
      formDetails.password,
      formDetails.confirmPassword,
    );
    if (passwordError) {
      setError(passwordError);
      return;
    }
    //   if (formDetails.password !== formDetails.confirmPassword) {
    //   setError("Passwords do not match.");
    //   return;
    // }
    setError(null);
    setIsLoading(true);
    await handleSetPassword();
    return;
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswordFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <GetStartedWrapper tocolumn={true}>
      <div className="first-section">
        <div className="logo-box-area">
          <Logo />
        </div>
        <div>
          <H3>A few clicks from creating your account </H3>
          <P>Easy Payroll management for your business all in one place!</P>
          <Prelim style={{ width: "100%", height: "auto" }} />
          <P className="foot">POWERED BY: FOCUS GROUP</P>
        </div>
      </div>
      <div className="emailAddress-page">
        <H2>Get started with workPlacePAY</H2>
        <P>
          Please provide the following details to set up your company with
          workPlacePAY
        </P>
        <form onSubmit={handleSubmit}>
          <BaseFieldSet>
            {step === 1 ? (
              <Label>Email Address:</Label>
            ) : (
              <Label>Password:</Label>
            )}
            <GetStartedWrapperRow step={step}>
              {step === 1 ? (
                <BaseInput
                  type="email"
                  name="email"
                  placeholder="john.doe@example.com"
                  required
                  value={formDetails.email}
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <Fragment>
                  <div style={{ position: "relative" }}>
                    <BaseInput
                      type={showPasswordFields.password ? "text" : "password"}
                      name="password"
                      placeholder="Enter Password"
                      required
                      value={formDetails.password}
                      onChange={(e) => handleChange(e)}
                      style={{
                        paddingRight: "60px",
                        borderColor:
                          error && error.toLowerCase().includes("password")
                            ? "red"
                            : "var(--color-primary-hover)",
                      }}
                    />
                    <span
                      onClick={() => togglePasswordVisibility("password")}
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "var(--color-primary)",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      }}
                    >
                      {showPasswordFields.password ? (
                        <FontAwesomeIcon icon={faEye} />
                      ) : (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      )}
                    </span>
                  </div>
                  <div style={{ position: "relative", marginTop: "1rem" }}>
                    <BaseInput
                      type={
                        showPasswordFields.confirmPassword ? "text" : "password"
                      }
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      required
                      value={formDetails.confirmPassword}
                      onChange={(e) => handleChange(e)}
                      style={{ paddingRight: "60px" }}
                    />
                    <span
                      onClick={() =>
                        togglePasswordVisibility("confirmPassword")
                      }
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "var(--color-primary)",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      }}
                    >
                      {showPasswordFields.confirmPassword ? (
                        <FontAwesomeIcon icon={faEye} />
                      ) : (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      )}
                    </span>
                  </div>
                </Fragment>
              )}
              <BaseButton type="submit" width={"fit-content"}>
                {isLoading ? (
                  <DotLoader size={20} color="white" className="dotLoader" />
                ) : (
                  <Span>Get Started</Span>
                )}
              </BaseButton>
            </GetStartedWrapperRow>
            {error && <P style={{ color: "red" }}>{error}</P>}
          </BaseFieldSet>
        </form>
      </div>
      <GetStartedSuccessModal
        ref={otpModalRef}
        width={"40%"}
        TOKEN={token}
        email={" " + userEmail}
        setIsOTPEntered={setIsOTPEntered}
      />
    </GetStartedWrapper>
  );
};
